import { logger } from 'src/commons/utils/logger';
import { CTCIPublisher } from 'src/commons/utils/metrics';

const MEASURE_KEY = 'aacchrome-nav-load-duration';
const NAV_START_MARK_NAME = 'aacchrome-nav-start';
const DURATION_FROM_PAGE_LOAD = 'durationFromPageLoad';
const DURATION_FROM_NAV_START = 'durationFromNavStart';
const DURATION_LOGGED_METRIC_FAILURE = 'navDurationFailure';

const publishNavLoadDuration = () => {
  try {
    // The nav-start mark is set by the host page, and most hosts never set it.
    // performance.measure throws a SyntaxError for a start mark that does not
    // exist, so check first and fall back to measuring from the time origin
    // (startTime 0), which is what the durationFromPageLoad metric records.
    const hasNavStartMark =
      performance.getEntriesByName(NAV_START_MARK_NAME, 'mark').length > 0;
    const measurement = hasNavStartMark
      ? performance.measure(MEASURE_KEY, NAV_START_MARK_NAME)
      : performance.measure(MEASURE_KEY);
    const metric =
      measurement.startTime === 0
        ? DURATION_FROM_PAGE_LOAD
        : DURATION_FROM_NAV_START;
    CTCIPublisher.publishTimerMonitor(metric, measurement.duration);
    CTCIPublisher.publishCounterMonitor(DURATION_LOGGED_METRIC_FAILURE, 0);
    performance.clearMeasures(MEASURE_KEY);
  } catch (e) {
    logger.error(
      `Failed to measure nav load: ${e instanceof Error ? e.message : String(e)}`,
    );
    CTCIPublisher.publishCounterMonitor(DURATION_LOGGED_METRIC_FAILURE, 1);
  } finally {
    performance.clearMarks(NAV_START_MARK_NAME);
  }
};

export default publishNavLoadDuration;
